import React, { useContext } from "react";
import "./main.styles.scss";
import DropDown from "../../assets/imgs/drop-down.svg";
import { ScrollContext } from "../../context/scroll-to";
import { scrollToSection } from "../../utils/scroller";
const Main = () => {
  const {aboutSection} = useContext(ScrollContext);
    return (
        <React.Fragment>
            <main className="main">
          <div className="intro">
            <h1 className="my-name">Abhishek</h1>
            <h3 className="my-des">I'm a <span className="job-Title"> web developer. </span></h3>
          </div>
          <div className="drop-down">
            <button onClick={() => scrollToSection(aboutSection)} className="drop-down-btn"><img src={DropDown} alt="drop down button"></img></button>
          </div>
        </main>
        </React.Fragment>
    );
}

export default Main;